module.exports = __webpack_public_path__ + "static/Eliza0-9148b2ed413ee1e66506c7caaf61eb5a.webp";